import styled from "styled-components"

export const BotaoExcluir = styled.button`
    padding: 5px;
    border-radius: 8px;
    border: red 0.5px solid;
    background-color: #F54D3D;
    color: #fff;
    text-shadow: 1px 1px #000000;

    :hover{
        background-color: #FF2511;
        color: #ffffff;
    }
`

